import { Link, Navigate } from '@tanstack/react-router';
import { useProjects } from '@/api/hooks';
import { EmptyState } from '@/components/EmptyState';
import { ErrorState } from '@/components/ErrorState';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';

/** /projects → the first project's Apps & profiles page, or the way to create one. */
export function ProjectsIndex() {
  const projects = useProjects();
  if (projects.isLoading && !projects.data) {
    return (
      <div className="flex flex-col gap-3" aria-busy="true">
        <Skeleton className="h-7 w-48" />
        <Skeleton className="h-4 w-72" />
      </div>
    );
  }
  if (projects.isError && !projects.data) return <ErrorState error={projects.error} onRetry={() => void projects.refetch()} />;
  const first = projects.data?.[0];
  if (first) return <Navigate to="/projects/$slug" params={{ slug: first.slug }} replace />;
  return (
    <EmptyState
      icon="account_tree"
      title="No projects yet"
      description="Apps live inside a project. Create the first one from Overview — staging, preprod and production come with it."
      action={
        <Button asChild>
          <Link to="/" hash="projects">
            Go to Overview
          </Link>
        </Button>
      }
    />
  );
}
